import React from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import Admonition from "../../components/Admonitions/Admonition"
import {cancelCheckDeposit} from "../../resources/checkDeposits"

interface CancelCheckModalProps {
	id: string
	closeModal: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function CancelCheckModal({id, closeModal, onSuccess}: CancelCheckModalProps) {
	const accessToken = useAccessToken()
	const [cancelState, setCancelState] = useAsyncResultIdle(cancelCheckDeposit)

	return (
		<AsyncResultModal
			title={`You are about to Cancel Check deposit with ID #${id}`}
			close={refreshAndClose(onSuccess, closeModal)}
			buttonClassname="is-danger"
			state={cancelState}
			buttonText="Cancel Check"
			successText="Check is cancelled"
			onSubmit={() => {
				setCancelState({id, accessToken})
			}}
			errorToText={(err) => err.errors[0].title}
		>
			<Admonition
				type={"is-danger"}
				message={
					<p>
						{
							"Cancelling a check is a final action that cannot be undone. The check deposit will be rejected with reason 'Cancelled'."
						}
					</p>
				}
				title={"Warning"}
			/>
		</AsyncResultModal>
	)
}
